import type { User } from "@assetwatch/auth";
import {
  MlFrontendFeatureDisabledError,
  MlFrontendUnauthorizedError,
} from "../errors/errors";

const ML_FRONTEND_ACCESS_ROLES = ["NikolaTeam"];

export type MlFrontendAccessFlags = {
  mlFrontendEnabled: boolean;
};

export type MlFrontendAccessInput = {
  flags: MlFrontendAccessFlags;
  user: User | null;
};

export function assertCanAccessMlFrontend({
  flags,
  user,
}: MlFrontendAccessInput): void {
  if (!flags.mlFrontendEnabled) {
    throw new MlFrontendFeatureDisabledError();
  }

  if (
    !ML_FRONTEND_ACCESS_ROLES.some(
      (accessRole) => user?.roles?.includes(accessRole) === true,
    )
  ) {
    throw new MlFrontendUnauthorizedError();
  }
}
